import http from "src/services/http";
import queryString from "query-string";
import store from "src/store";
import * as types from "../types/categorias_produtos";

export const cadastrar = (categoria) => {
  const { filtro } = store.getState().categorias_produtos;
  store.dispatch({ type: types.LOADING_PRODUTOS_CATEGORIA, payload: true });
  return http.post(`/api/v2/empresa/produtos/categorias`, categoria).then(
    (response) => {
      store.dispatch(pesquisarCategorias(filtro));
    },
    (error) => {
      console.log(error);
      store.dispatch([
        { type: types.LOADING_PRODUTOS_CATEGORIA, payload: false },
      ]);
    }
  );
};

export const atualizar = ({ id, ...categoria }) => {
  const { filtro } = store.getState().categorias_produtos;
  store.dispatch({ type: types.LOADING_PRODUTOS_CATEGORIA, payload: true });
  return http.put(`/api/v2/empresa/produtos/categorias/${id}`, categoria).then(
    (response) => {
      store.dispatch(pesquisarCategorias(filtro));
    },
    (error) => {
      store.dispatch([
        { type: types.LOADING_PRODUTOS_CATEGORIA, payload: false },
      ]);
    }
  );
};

export const pesquisarCategorias = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/produtos/categorias?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.LOAD_PRODUTOS_CATEGORIAS, payload: data },
          { type: types.SET_PAGE_PRODUTOS_CATEGORIA, payload: parseInt(page) },
          {
            type: types.SET_TOTAL_PRODUTOS_CATEGORIA,
            payload: parseInt(total),
          },
          {
            type: types.SET_PERPAGE_PRODUTOS_CATEGORIA,
            payload: parseInt(per_page),
          },
          { type: types.LOADING_PRODUTOS_CATEGORIA, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.LOADING_PRODUTOS_CATEGORIA, payload: false }]);
      }
    );
  };
};

export const excluirCategoria = (id) => {
  const { filtro } = store.getState().categorias_produtos;
  store.dispatch({ type: types.LOADING_PRODUTOS_CATEGORIA, payload: true });
  http.delete(`/api/v2/empresa/produtos/categorias/${id}`).then(
    (response) => {
      store.dispatch(pesquisarCategorias(filtro));
    },
    (error) => {
      store.dispatch([
        { type: types.LOADING_PRODUTOS_CATEGORIA, payload: false },
      ]);
    }
  );
};
